// Interest-type display language. MineralTransaction#interest_type carries the
// domain codes PT (Primary Term) and HBP (Held By Production), sourced from
// imports. The read UI shows the short code and surfaces the full name on hover.

/** Full names for the known interest-type codes. */
const INTEREST_TYPE_LABELS: Record<string, string> = {
  PT: "Primary Term",
  HBP: "Held By Production",
  Open: "Open (Unleased)",
}

// Badge accents: PT reads blue, HBP reads green, Open reads amber. Kept apart
// from the ACQ/DIV green so an HBP pill never scans as an Acquisition pill.
const INTEREST_TYPE_COLORS: Record<string, string> = {
  PT: "#3b82b8",
  HBP: "#43a06b",
  Open: "#c08a3e",
}

/**
 * Full name for an interest-type code (e.g. "PT" -> "Primary Term"). Unknown or
 * blank values fall back to the code itself so imported one-offs still render.
 */
export function interestTypeLabel(code: string | null | undefined): string {
  if (!code) return ""
  return INTEREST_TYPE_LABELS[code] ?? code
}

/**
 * Badge accent color for an interest-type code (PT blue, HBP green, Open
 * amber). Unknown codes return null so callers fall back to the neutral style.
 */
export function interestTypeColor(code: string | null | undefined): string | null {
  if (!code) return null
  return INTEREST_TYPE_COLORS[code] ?? null
}
